if (!customElements.get("floating-atc")) {
  class FloatingATC extends HTMLElement {
    constructor() {
      super();
      
      this.form = this.closest(".product-form");
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      theme.waitForElement(".appstle_sub_widget", 3000).then(this.initAppstleWidget.bind(this)).catch(()=>
      {
        // console.log("Timed out. Appstle widget not loaded.");
      });

      // Clone entire quantity-submit-row
      this.quantitySubmitRow = this.form.querySelector('.quantity-submit-row');
      const quantitySubmitRowWrapper = this.querySelector('.floating-atc__quantity-submit-wrapper');
      
      if (this.quantitySubmitRow) {
        // Clone specific elements only
        const quantityWrapper = this.quantitySubmitRow.querySelector('quantity-wrapper');
        const submitButton = this.quantitySubmitRow.querySelector('.quantity-submit-row__submit');
        
        if (quantityWrapper) {
          const quantityWrapperClone = quantityWrapper.cloneNode(true);
          theme.suffixIds(quantityWrapperClone, '_dupe');
          quantitySubmitRowWrapper.appendChild(quantityWrapperClone);
          
          // Sync quantity inputs between original and clone
          const quantityInput = quantityWrapper.querySelector('#quantity');
          const quantityInputClone = quantityWrapperClone.querySelector('#quantity_dupe');
          
          if (quantityInput && quantityInputClone) {
            this.syncQuantityHandler = (evt) => {
              if (evt.target.id === 'quantity') {
                quantityInputClone.value = evt.target.value;
              } else if (evt.target.id === 'quantity_dupe') {
                quantityInput.value = evt.target.value;
              }
            };
            
            quantityInput.addEventListener('input', this.syncQuantityHandler);
            quantityInput.addEventListener('change', this.syncQuantityHandler);
            quantityInputClone.addEventListener('input', this.syncQuantityHandler);
            quantityInputClone.addEventListener('change', this.syncQuantityHandler);
          }
        }
        
        if (submitButton) {
          const submitButtonClone = submitButton.cloneNode(true);
          theme.suffixIds(submitButtonClone, '_dupe');
          quantitySubmitRowWrapper.appendChild(submitButtonClone);
          
          // Delegate clicks from cloned .rbr-bap-new-footer to original
          const clonedFooter = submitButtonClone.querySelector('.rbr-bap-new-footer');
          const originalFooter = submitButton.querySelector('.rbr-bap-new-footer');
          
          if (clonedFooter && originalFooter) {
            // make clonedFooter clickable
            clonedFooter.style.setProperty('cursor', 'pointer', 'important');

            this.clickDelegationHandler = (evt) => {
              evt.preventDefault();
              evt.stopPropagation();

              if (clonedFooter.getAttribute('disabled') === 'true') {
                const productInfoBox = this.form.querySelector('.product-info-box');
                if (productInfoBox) {
                  const elementPosition = productInfoBox.getBoundingClientRect().top + window.pageYOffset;
                  const offsetPosition = elementPosition - theme.stickyHeaderHeight();
                  window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                }
              }
              originalFooter.click();

            };
            clonedFooter.addEventListener('click', this.clickDelegationHandler);
          }
        }

        // Set up MutationObserver to sync changes from original to clone
        if ('MutationObserver' in window) {
          this.rowObserver = new MutationObserver(debounce(this.syncQuantitySubmitRow.bind(this), 250));
          this.rowObserver.observe(this.quantitySubmitRow, { 
            attributes: true, 
            childList: true, 
            subtree: true,
            characterData: true
          });
        }

        // Get reference to submit button for intersection observer
        const submitButtonElement = this.quantitySubmitRow.querySelector('.quantity-submit-row__submit');
        
        if (submitButtonElement) {
          // Show the floating bar if the submit button scrolled past the top of viewport
          if ('IntersectionObserver' in window) {
            this.intersectionObserver = new IntersectionObserver((entries, observer) => {
              entries.forEach((entry) => {

                const isIntersectingAtTop = entry.rootBounds.bottom - entry.boundingClientRect.bottom > entry.rootBounds.bottom / 2;
                if (isIntersectingAtTop) {
                  if (entry.isIntersecting) {
                    this.classList.remove('slide-up');
                  } else {
                    this.classList.add('slide-up');
                  }
                }
              });
            }, { root: document, rootMargin: "-" + theme.stickyHeaderHeight() + "px 0px 0px 0px", threshold: 0 });

            this.intersectionObserver.observe(submitButtonElement);
          }
          // Handle the scroll event to show/hide the floating bar when scrolled to the bottom of the page
          this.throttledOnScrollHandler = throttle(this.handleScroll.bind(this));
          window.addEventListener('scroll', this.throttledOnScrollHandler);
        }
      }

      this.setAttribute("loaded", "");
    }

    handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }

    initAppstleWidget() {

      this.oneTimePurchaseRadio = this.form.querySelector('.appstle_subscription_wrapper_option:first-child input[type="radio"]');
      this.sellingPlanRadio = this.form.querySelector('.appstle_subscription_wrapper_option:last-child input[type="radio"]');
      this.oneTimePurchasePrice = this.form.querySelector('.appstle_subscription_wrapper_option:first-child .appstle_subscription_amount');
      this.sellingPlanPrice = this.form.querySelector('.appstle_subscription_wrapper_option:last-child .appstle_subscription_amount');
      this.floatingBarPrice = this.form.querySelector('.floating-atc__desc--price .price');
      this.floatingBarVariant = this.querySelector('.floating-atc__desc--price .size');
      
      // Clone selling plan selector
      this.sellingPlanSelector = this.form.querySelector('.appstle_select');
      if (this.sellingPlanSelector) {

        // Create the select element
        this.sellingPlanSelectorClone = document.createElement("select");
        this.sellingPlanSelectorClone.classList.add('floating-atc__selling_plan');

        // Insert one-time purchase option
        let opt = document.createElement('option');
        opt.value = 'onetime';
        opt.text = this.form.querySelector('.appstle_one_time_text').innerText;
        this.sellingPlanSelectorClone.appendChild(opt);
        
        // Insert the subscription plan options
        const auto_replenish_word = this.form.querySelector(".appstle_subscribe_save_text").innerText.replace(/ .*/,'');
        [...this.sellingPlanSelector.children].forEach((child) => {
          let opt = document.createElement('option');
          opt.value = child.value;
          opt.text = auto_replenish_word + " " + child.innerText
          this.sellingPlanSelectorClone.appendChild(opt);
        });

        // Insert selector into the floating bar
        this.form.querySelector('.floating-atc-wrapper').insertBefore(this.sellingPlanSelectorClone, this.form.querySelector('.floating-atc__quantity-submit-wrapper'))
        this.selectSellingPlan();

        // Add Appstle listeners
        this.selectSellingPlanHandler = this.selectSellingPlan.bind(this);
        document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanRemoved', this.selectSellingPlanHandler);
        document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', this.selectSellingPlanHandler);
        this.sellingPlanSelector.addEventListener('change', this.selectSellingPlanHandler);

        this.syncSellingPlanHandler = this.syncSellingPlan.bind(this);
        this.sellingPlanSelectorClone.addEventListener('change', this.syncSellingPlanHandler);

        // not needed now as variant change will trigger refresh of the widget using data-dynamic-variant-content
        // Add listener if variant changed
        // this.updateVariantHandler = this.updateVariant.bind(this);
        // document.addEventListener('on:variant:change', this.updateVariantHandler);

        // Add listener when the widget reloads
        this.reloadAppstleWidgetHandler = this.reloadAppstleWidget.bind(this);
        jQuery(document).on("appstle_widget_updated", this.reloadAppstleWidgetHandler);

      }
    }

    reloadAppstleWidget() {
      // Refresh the references when the widget reloads
      this.oneTimePurchaseRadio = this.form.querySelector('.appstle_subscription_wrapper_option:first-child input[type="radio"]');
      this.sellingPlanRadio = this.form.querySelector('.appstle_subscription_wrapper_option:last-child input[type="radio"]');
      this.oneTimePurchasePrice = this.form.querySelector('.appstle_subscription_wrapper_option:first-child .appstle_subscription_amount');
      this.sellingPlanPrice = this.form.querySelector('.appstle_subscription_wrapper_option:last-child .appstle_subscription_amount');

      // Reattach the selector event
      this.sellingPlanSelector.removeEventListener('change', this.selectSellingPlanHandler);
      this.sellingPlanSelector = this.form.querySelector('.appstle_select');
      this.sellingPlanSelector.addEventListener('change', this.selectSellingPlanHandler);

      // Update the pricing
      this.selectSellingPlan();
    }
    
    // updateVariant(evt) {
    //   this.floatingBarVariant.innerText = evt.detail.variant.title;
    // }

    selectSellingPlan() {
      if(this.oneTimePurchaseRadio.checked) {
        this.sellingPlanSelectorClone.selectedIndex = 0;
        this.floatingBarPrice.innerText = this.oneTimePurchasePrice.innerText;
      }
      else {
        this.sellingPlanSelectorClone.selectedIndex = this.sellingPlanSelector.selectedIndex + 1;
        this.floatingBarPrice.innerText = this.sellingPlanPrice.innerText;
      }
    }

    syncSellingPlan() {      
      if(this.sellingPlanSelectorClone.selectedIndex == 0) {
        this.oneTimePurchaseRadio.checked = true;
        this.oneTimePurchaseRadio.dispatchEvent(new Event("change"));
      }
      else {
        this.sellingPlanSelector.selectedIndex = this.sellingPlanSelectorClone.selectedIndex - 1;
        this.sellingPlanRadio.checked = true;
        this.sellingPlanRadio.dispatchEvent(new Event("change"));
      }
    }

    syncQuantitySubmitRow(mutations) {
      // Remove old event listeners before re-cloning
      if (this.syncQuantityHandler) {
        const oldQuantityInput = document.getElementById('quantity');
        const oldQuantityInputClone = document.getElementById('quantity_dupe');
        if (oldQuantityInput) {
          oldQuantityInput.removeEventListener('input', this.syncQuantityHandler);
          oldQuantityInput.removeEventListener('change', this.syncQuantityHandler);
        }
        if (oldQuantityInputClone) {
          oldQuantityInputClone.removeEventListener('input', this.syncQuantityHandler);
          oldQuantityInputClone.removeEventListener('change', this.syncQuantityHandler);
        }
      }
      
      // Clear the wrapper and re-clone specific elements
      const quantitySubmitRowWrapper = this.querySelector('.floating-atc__quantity-submit-wrapper');
      quantitySubmitRowWrapper.innerHTML = '';
      
      const quantityWrapper = this.quantitySubmitRow.querySelector('quantity-wrapper');
      const submitButton = this.quantitySubmitRow.querySelector('.quantity-submit-row__submit');
      
      if (quantityWrapper) {
        const quantityWrapperClone = quantityWrapper.cloneNode(true);
        theme.suffixIds(quantityWrapperClone, '_dupe');
        quantitySubmitRowWrapper.appendChild(quantityWrapperClone);
        
        // Re-attach quantity sync event listeners
        const quantityInput = quantityWrapper.querySelector('#quantity');
        const quantityInputClone = quantityWrapperClone.querySelector('#quantity_dupe');
        
        if (quantityInput && quantityInputClone) {
          this.syncQuantityHandler = (evt) => {
            if (evt.target.id === 'quantity') {
              quantityInputClone.value = evt.target.value;
            } else if (evt.target.id === 'quantity_dupe') {
              quantityInput.value = evt.target.value;
            }
          };
          
          quantityInput.addEventListener('input', this.syncQuantityHandler);
          quantityInput.addEventListener('change', this.syncQuantityHandler);
          quantityInputClone.addEventListener('input', this.syncQuantityHandler);
          quantityInputClone.addEventListener('change', this.syncQuantityHandler);
        }
      }
      
      if (submitButton) {
        const submitButtonClone = submitButton.cloneNode(true);
        theme.suffixIds(submitButtonClone, '_dupe');
        quantitySubmitRowWrapper.appendChild(submitButtonClone);
        
        // Delegate clicks from cloned .rbr-bap-new-footer to original
        const clonedFooter = submitButtonClone.querySelector('.rbr-bap-new-footer');
        const originalFooter = submitButton.querySelector('.rbr-bap-new-footer');
        
        if (clonedFooter && originalFooter) {
          // make clonedFooter clickable
          clonedFooter.style.setProperty('cursor', 'pointer', 'important');

          this.clickDelegationHandler = (evt) => {
            evt.preventDefault();
            evt.stopPropagation();

            if (clonedFooter.getAttribute('disabled') === 'true') {
              const productInfoBox = this.form.querySelector('.product-info-box');
              if (productInfoBox) {
                const elementPosition = productInfoBox.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - theme.stickyHeaderHeight();
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
              }
            }
            originalFooter.click();

          };
          clonedFooter.addEventListener('click', this.clickDelegationHandler);
        }
      }
    }
    
    disconnectedCallback() {
      if (this.selectSellingPlanHandler) {
        document.removeEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanRemoved', this.selectOneTimePurchaseHandler);
        document.removeEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', this.selectSellingPlanHandler);
        this.sellingPlanSelector.removeEventListener('change', this.selectSellingPlanHandler);
      }
      if (this.syncSellingPlanHandler) {
        this.sellingPlanSelectorClone.removeEventListener('change', this.syncSellingPlanHandler);
      }
      if (this.syncQuantityHandler) {
        const quantityInput = document.getElementById('quantity');
        const quantityInputClone = document.getElementById('quantity_dupe');
        if (quantityInput) {
          quantityInput.removeEventListener('input', this.syncQuantityHandler);
          quantityInput.removeEventListener('change', this.syncQuantityHandler);
        }
        if (quantityInputClone) {
          quantityInputClone.removeEventListener('input', this.syncQuantityHandler);
          quantityInputClone.removeEventListener('change', this.syncQuantityHandler);
        }
      }
      if (this.clickDelegationHandler) {
        const clonedFooter = this.querySelector('.rbr-bap-new-footer');
        if (clonedFooter) {
          clonedFooter.removeEventListener('click', this.clickDelegationHandler);
        }
      }
      if (this.reloadAppstleWidgetHandler) {
        jQuery(document).off("appstle_widget_updated");
      }
      if (this.rowObserver) {
        this.rowObserver.disconnect();
      }
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
      if (this.throttledOnScrollHandler) {
        window.removeEventListener('scroll', this.throttledOnScrollHandler);
      }
    }
  }

  customElements.define("floating-atc", FloatingATC);
}
